import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DashboardTabBarChart from './DashboardTabBarChart';
import DashboardTabBarChartEdit from './DashboardTabBarChart/BarChartEdit';
import DashboardTabBigTable from './DashboardTabBigTable';
import DashboardTabBigTableEdit from './DashboardTabBigTable/BigTableEdit';
import DashboardTabDonutChart from './DashboardTabDonutChart';
import DashboardTabDonutChartEdit from './DashboardTabDonutChart/DonutChartEdit';
import DashboardTabEmbedded from './DashboardTabEmbedded';
import DashboardTabEmbeddedEdit from './DashboardTabEmbedded/EmbeddedEdit';
import DashboardTabTable from './DashboardTabTable';
import DashboardTabTableEdit from './DashboardTabTable/TableEdit';
import { updateDashboardPartData as updateDashboardTabData } from '../../../actions/DashboardActions';

const DashboardTab = ({ part, tab, mode, onTabChange, onEdit, onAccept, onDelete, onCancel }) => {
  const dispatch = useDispatch();
  const tabEdit = useSelector((state) => state.dashboardConfig.tabEdit);
  const lastSelectedSearchNames = useSelector(
    (state) => state.savedSearchFilters.lastSelectedSearchNames
  );

  function handleTabDataUpdate(id, data) {
    dispatch(updateDashboardTabData(id, data));
  }

  const tabProps = {
    part,
    tab,
    mode,
    onEdit,
    onDelete,
    onTabChange,
    onUpdateData: handleTabDataUpdate,
    lastSelectedSearchNames,
  };

  const tabEditProps = {
    part,
    tab,
    onAccept,
    onCancel,
  };

  const openEditDialog = tabEdit.id === tab.id;

  switch (tab.visualization) {
    case 'table':
      return (
        <>
          <DashboardTabTable {...tabProps} />
          {openEditDialog && <DashboardTabTableEdit {...tabEditProps} />}
        </>
      );
    case 'bar':
      return (
        <>
          <DashboardTabBarChart {...tabProps} />
          {openEditDialog && <DashboardTabBarChartEdit {...tabEditProps} />}
        </>
      );
    case 'donut':
      return (
        <>
          <DashboardTabDonutChart {...tabProps} />
          {openEditDialog && <DashboardTabDonutChartEdit {...tabEditProps} />}
        </>
      );
    case 'bigtable':
      return (
        <>
          <DashboardTabBigTable {...tabProps} />
          {openEditDialog && <DashboardTabBigTableEdit {...tabEditProps} />}
        </>
      );
    case 'embedded':
      return (
        <>
          <DashboardTabEmbedded {...tabProps} />
          {openEditDialog && <DashboardTabEmbeddedEdit {...tabEditProps} />}
        </>
      );
    default:
  }

  return <p>{`Invalid Dashboard visualization type: ${tab.visualization}`}</p>;
};

export default DashboardTab;
